import React from 'react';
import { wrap, cardStyle } from './styles';

/** Centered card used for loading / error / disabled-feature messages. */
export default function Centered({ children }) {
  return (
    <div style={wrap}>
      <div style={{ ...cardStyle, textAlign: 'center', color: '#64748b' }}>{children}</div>
    </div>
  );
}
